import { render, staticRenderFns } from "./CompositeBoxForNumber.vue?vue&type=template&id=0708cc19&scoped=true"
import script from "./CompositeBoxForNumber.vue?vue&type=script&lang=js"
export * from "./CompositeBoxForNumber.vue?vue&type=script&lang=js"
import style0 from "./CompositeBoxForNumber.vue?vue&type=style&index=0&id=0708cc19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0708cc19",
  null
  
)

export default component.exports